"use client";

import { IReactiveMediaContentItem } from "../../components/schoolfeed/SchoolFeedContentItem";
import { observer } from "mobx-react";
import {
  IFallbackData,
  ISchoolFeedUrlQueries,
} from "../../utils/SchoolBlocksUtilities";
import { GalleryItem } from "./GalleryItem";
import { deleteContentItem } from "../../components/blocks/TerracedGridTheme/Terrace";
import { useSchoolFeedInfiniteScroll } from "../../components/schoolfeed/hooks/useSchoolFeedInfiniteScroll";
import { use } from "react";
import { Box, Button } from "@radix-ui/themes";

export type SchoolFeedMediaDisplayProps = {
  urlQuery: ISchoolFeedUrlQueries;
};

export const GalleryContent = observer(
  (props: { initialMediaPromise: Promise<IFallbackData> }) => {
    const {
      contentItems,
      totalContentItems,
      getItemAtIndex,
      mutate,
      isValidating,
    } = useSchoolFeedInfiniteScroll(
      "media",
      {
        is_media: true,
        expand: ["organization"],
      },
      use(props.initialMediaPromise),
    );

    async function handleDeleteContentItem(
      contentItem: IReactiveMediaContentItem,
    ) {
      await deleteContentItem(contentItem);
      await mutate();
    }

    return !isValidating && contentItems.length === 0 ? (
      <Box py={"6"}>
        <h3>No media items found.</h3>
      </Box>
    ) : (
      contentItems.map((item, idx) => (
        <GalleryItem
          key={item.id}
          item={item as IReactiveMediaContentItem}
          getItemAtIndex={getItemAtIndex}
          totalItemCount={totalContentItems}
          initialItemIndex={idx}
          handleDeleteContentItem={handleDeleteContentItem}
        />
      ))
    );
  },
);

export function GalleryViewMore(props: {
  initialMediaPromise: Promise<IFallbackData>;
}) {
  const { isValidating, size, setSize, totalContentItems, contentItems } =
    useSchoolFeedInfiniteScroll(
      "media",
      {
        is_media: true,
        expand: ["organization"],
      },
      use(props.initialMediaPromise),
    );

  return (
    <Box mt={"4"} style={{ textAlign: "center" }}>
      <Button
        disabled={isValidating || contentItems.length === totalContentItems}
        onClick={() => setSize(size + 1)}
        loading={isValidating}
      >
        View More
      </Button>
    </Box>
  );
}
